import { render, staticRenderFns } from "./ManageMarkupLegacy.vue?vue&type=template&id=2f49dfb7&scoped=true&"
import script from "./ManageMarkupLegacy.vue?vue&type=script&lang=js&"
export * from "./ManageMarkupLegacy.vue?vue&type=script&lang=js&"
import style0 from "./ManageMarkupLegacy.vue?vue&type=style&index=0&id=2f49dfb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f49dfb7",
  null
  
)

export default component.exports